import { Button, EButtonColorVariant, Text } from '@outdoorsyco/bonfire';
import { FormattedMessage, useIntl } from 'react-intl';

import { openSessionModal } from '@/utility/session';

export const WishlistsAuthPrompt = () => {
  const intl = useIntl();

  const createAccountBtnLabel = intl.formatMessage({
    defaultMessage: 'Create account',
    id: 'huqKGl',
  });
  const loginBtnLabel = intl.formatMessage({
    defaultMessage: 'Login',
    id: 'AyGauy',
  });

  return (
    <div className="flex flex-col max-w-28 gap-8">
      <Text>
        <FormattedMessage
          defaultMessage="Create an account or log in to save your favorite RV rentals, campgrounds and more."
          id="FjT/8p"
        />
      </Text>
      <div className="flex flex-col gap-4">
        <Button
          label={createAccountBtnLabel}
          aria-label={createAccountBtnLabel}
          variant={EButtonColorVariant.Primary}
          onClick={() => openSessionModal('signup')}
        />
        <Button
          label={loginBtnLabel}
          aria-label={loginBtnLabel}
          variant={EButtonColorVariant.Secondary}
          onClick={() => openSessionModal('login')}
        />
      </div>
    </div>
  );
};
